import { Dispatch, SetStateAction } from "react";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  isCreating: boolean;
  setIsCreating: Dispatch<SetStateAction<boolean>>;
  onClose: Dispatch<SetStateAction<void>>;
  handleChange: () => void;
  handleCreate: () => void;
};

export const OptionDialogButtonGroup = ({
  isCreating,
  setIsCreating,
  onClose,
  handleChange,
  handleCreate
}: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      data-testid="option-btn-group-save"
      sx={{ width: "100%" }}
      onClick={() => {
        if (!isCreating) {
          handleChange();
          onClose();
          return;
        }

        handleCreate();
        setIsCreating(false);
        onClose();
      }}
    >
      {t("Save")}
    </Button>
  );
};
